<div class="white-box main-black mt-4 p-4 border-radius">
	<div class="row mb-4">
		<div class="col">
			<h4>
				{{'chargers_performance.monthly_quarterly_usage_report' | translate}}
			</h4>
		</div>
	</div>

	<div class="mb-2">
		<!-- years list -->
		<div class="col-sm-6 col-md-3 d-inline-flex">
			<ng-select [searchable]="false" class="mr-auto w-100" [items]="yearList" bindLabel="label" bindValue="id" placeholder="{{'site.year' | translate}}" name="year" [(ngModel)]="selectedYear" (ngModelChange)="selectYear()" [clearable]="false">
			</ng-select>
		</div>

		<!-- Monthly or Quarterly drop-down -->
		<div class="col-sm-6 col-md-3 d-inline-flex" *ngIf="!isAllYearsSelected()">
			<ng-select [searchable]="false" class="mr-auto w-100" [items]="periodTypes" bindLabel="label" bindValue="id" placeholder="{{'perf_analytic.period' | translate}}" name="period" [(ngModel)]="selectedPeriodType" (ngModelChange)="changePeriodType()" [clearable]="false">
			</ng-select>
		</div>
	</div>

	<!-- table -->
	<div class="col-12">
		<sct-custom-table
			#sctCustomTable
			[columnsConfig]="columnConfig"
			[data]="tableData"
			[config]="tableConfig"
		></sct-custom-table>
	</div>
</div>
